export default {"src":"/_next/static/media/rowing.colour.39d81dbb.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};